const UserRoles = Object.freeze({
    INACTIVE: "INACTIVE",
    USER: "USER",
    VENDOR: "VENDOR",
    MANAGER: "MANAGER",
    ADMIN: "ADMIN",
    CLIENT: "CLIENT",
    SUPER: "SUPER",
  });
  
  export default UserRoles;